import { StoreState } from "store/index";

export const getFareOffersWithDetails = (state: StoreState) => state.brandedFares.fareOffersWithDetails;
